<template>
  <div>
    <navigation-sub
      :list="[
        {
          title: $t('deliveryTakeaway.food.name')
        },
        {
          title: $t('deliveryTakeaway.takeOut.name')
        },
        {
          title: $t('deliveryTakeaway.robots.name')
        }
      ]"
    />

    <section class="service-title-wrap">
      <h4 class="service-title">{{ $t('menuService.deliveryTakeout') }}</h4>
    </section>

    <section class="service-list">
      <!-- 음식배달 -->
      <article :id="hashTitle($t('deliveryTakeaway.food.name'))" class="article-anchor">
        <!-- 한집배달 -->
        <div class="service-box" :data-id="$t('deliveryTakeaway.baeminOne.name')">
          <div class="service-box-image">
            <p>
              <img src="~@/static/image/service/one.jpg" :alt="$t('deliveryTakeaway.baeminOne.name')">
            </p>
          </div>
          <div class="service-box-title">
            <img src="~@/static/image/logo-family/new_logo_one.png" :alt="$t('deliveryTakeaway.baeminOne.name')">
            <html-view tag="p" :value="$t('deliveryTakeaway.baeminOne.title')" />
          </div>
          <div class="service-box-content">
            <html-view :value="$t('deliveryTakeaway.baeminOne.content')" />
          </div>
        </div>
        <!-- 알뜰배달 -->
        <div class="service-box" :data-id="$t('deliveryTakeaway.lower.name')">
          <div class="service-box-title">
            <img src="~@/static/image/logo-family/new_logo_thrifty.png" :alt="$t('deliveryTakeaway.lower.name')">
            <html-view tag="p" :value="$t('deliveryTakeaway.lower.title')" />
          </div>
          <div class="service-box-content">
            <html-view :value="$t('deliveryTakeaway.lower.content')" />
          </div>
        </div>
        <!-- 배민클럽 -->
        <div class="service-box" :data-id="$t('deliveryTakeaway.club.name')">
          <div class="service-box-title">
            <img src="~@/static/image/logo-family/new_logo_club.png" :alt="$t('deliveryTakeaway.club.name')">
            <html-view tag="p" :value="$t('deliveryTakeaway.club.title')" />
          </div>
          <div class="service-box-content">
            <html-view :value="$t('deliveryTakeaway.club.content')" />
          </div>
        </div>
        <!-- 한그릇 -->
        <div class="service-box" :data-id="$t('deliveryTakeaway.mfo.name')">
          <div class="service-box-title">
            <img src="~@/static/image/logo-family/logo_mfo.png" :alt="$t('deliveryTakeaway.mfo.name')">
            <html-view tag="p" :value="$t('deliveryTakeaway.mfo.title')" />
          </div>
          <div class="service-box-content">
            <html-view :value="$t('deliveryTakeaway.mfo.content')" />
          </div>
        </div>
      </article>

      <!-- 픽업 -->
      <article :id="hashTitle($t('deliveryTakeaway.takeOut.name'))" class="article-anchor">
        <div class="service-box" :data-id="$t('deliveryTakeaway.takeOut.name')">
          <div class="service-box-image">
            <p>
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/service/pc/takeout@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/service/m/takeout@3x.jpg 3x">
                <img src="~@/static/image/service/pc/takeout.jpg" :alt="$t('deliveryTakeaway.takeOut.name')">
              </picture>
            </p>
          </div>
          <div class="service-box-title">
            <img src="~@/static/image/logo-family/new_logo_takeout.png" :alt="$t('deliveryTakeaway.takeOut.name')">
            <html-view tag="p" :value="$t('deliveryTakeaway.takeOut.title')" />
          </div>
          <div class="service-box-content">
            <html-view :value="$t('deliveryTakeaway.takeOut.content')" />
          </div>
        </div>
      </article>

      <!-- 로봇 -->
      <article :id="hashTitle($t('deliveryTakeaway.robots.name'))" class="article-anchor">
        <div class="service-box" :data-id="$t('deliveryTakeaway.robots.name')">
          <div class="service-box-image">
            <p>
              <picture>
                <source media="(min-width: 750px)" srcset="~@/static/image/service/pc/robot2@3x.jpg 3x">
                <source media="(max-width: 750px)" srcset="~@/static/image/service/m/robot2.jpg 3x">
                <img src="~@/static/image/service/pc/robot2.jpg" :alt="$t('deliveryTakeaway.robots.name')">
              </picture>
            </p>
          </div>
          <div class="service-box-title">
            <img src="~@/static/image/logo-family/new_logo_robot.png" :alt="$t('deliveryTakeaway.robots.name')">
            <html-view tag="p" :value="$t('deliveryTakeaway.robots.title')" />
          </div>
          <div class="service-box-content">
            <html-view :value="$t('deliveryTakeaway.robots.content')" />
            <div class="btn-wrap">
              <a
                href="https://robot.baemin.com/"
                class="btn-link"
                target="_blank"
                @click="setGtag({
                  name: '서비스_페이지 링크',
                  category: '배달/픽업',
                  label: '서비스링크_배민로봇',
                  page: '서비스'})"
              >{{ $t('deliveryTakeaway.robots.site') }}<icon-blank /></a>
            </div>
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import gtag from '@/mixins/gtag'
import { hashTitle } from '@/util'

export default {
  components: {
    navigationSub: () => import('@/components/base/NavigationSub'),
    iconBlank: () => import('@/static/svg/blank.svg'),
  },
  mixins: [gtag],
  methods: { hashTitle },
}
</script>
